import { render, staticRenderFns } from "./UiModal.vue?vue&type=template&id=ee7b6a0e&"
import script from "./UiModal.vue?vue&type=script&lang=js&"
export * from "./UiModal.vue?vue&type=script&lang=js&"
import style0 from "./UiModal.vue?vue&type=style&index=0&id=ee7b6a0e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports